import React from "react";
import img1 from "../Assets/aboutus-1.png";
import "./oneonone.css";

function Oneonone() {
  return (
    <div className="oneonone-container">
      <div className="oneonone-image">
        <img src={img1} alt="Doctor with patient" />
      </div>
      <div className="oneonone-content">
        <h2>1-On-1 Care. One-In-A-Million Expertise</h2>
        <div>
          Rooted in trust and driven by innovation, Shri Adithya hospital is a
          center of excellence where advanced medical technology is powered by
          world class expertise.
        </div>
        <div>
          Whether it's a routine check-up or a critical procedure, our focus
          remains the same <span>YOU</span>
        </div>
      </div>
    </div>
  );
}

export default Oneonone;
